function initProductInventory() {
  const inventoryContainer = document.getElementById('inventory-status');
  if (!inventoryContainer) return;

  const formId = inventoryContainer.dataset.productForm;
  const productForm = document.getElementById(formId);
  if (!productForm) return;

  const inStockEl = inventoryContainer.querySelector('.in-stock');
  const reserveEl = inventoryContainer.querySelector('.reserve');
  const variants = JSON.parse(document.getElementById('product-variants-json').textContent);

  function updateInventory(variantId) {
    const variant = variants.find(v => v.id == variantId);
    if (!variant) return;

    if (variant.inventory_quantity > 0) {
      inStockEl.style.display = 'block';
      reserveEl.style.display = 'none';
    } else {
      inStockEl.style.display = 'none';
      reserveEl.style.display = 'block';
    }
  }

  productForm.addEventListener('change', function(e) {
    if (e.target.name === 'id') {
      updateInventory(e.target.value);
    }
  });
}

document.addEventListener('DOMContentLoaded', initProductInventory);
